import { z } from 'zod';

export const DPQAEndpoints = z.object({
  buckets: z.array(z.string()).describe('names of s3 buckets which need to be reachable'),
  sqs: z.string().describe('name of SQS queue which needs to be reachable'),
});

export type DPQAEndpointsType = z.infer<typeof DPQAEndpoints>;
